import { Link } from 'react-router-dom';
import { Property } from '../../types/user';
import { Card } from '../ui/Card';
import { PencilIcon, TrashIcon, UserIcon } from '@heroicons/react/24/outline';

interface PropertyCardProps {
  property: Property;
  onEdit: () => void;
  onDelete: () => void;
  onUserManagement: () => void;
}

export const PropertyCard = ({ property, onEdit, onDelete, onUserManagement }: PropertyCardProps) => {
  return (
    <Card className="relative">
      <div className="absolute top-4 right-4 flex space-x-2">
        <button
          onClick={onEdit}
          className="p-1 text-gray-500 hover:text-red-600 transition-colors"
        >
          <PencilIcon className="h-5 w-5" />
        </button>
        <button
          onClick={onDelete}
          className="p-1 text-gray-500 hover:text-red-600 transition-colors"
        >
          <TrashIcon className="h-5 w-5" />
        </button>
      </div>

      <Link to={`/property/${property.id}`} className="block">
        <h3 className="text-xl font-semibold mb-2">{property.name}</h3>
        <p className="text-gray-600 mb-4">{property.location}</p>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-500">Facturación</p>
            <p className="text-lg font-semibold">{Math.round(property.stats.revenue).toLocaleString()}€</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Ocupación</p>
            <p className="text-lg font-semibold">{Math.round(property.stats.occupancyRate)}%</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Beneficio</p>
            <p className="text-lg font-semibold">{Math.round(property.stats.profit).toLocaleString()}€</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Reservas</p>
            <p className="text-lg font-semibold">{property.stats.reservations}</p>
          </div>
        </div>
      </Link>

      <button
        onClick={onUserManagement}
        className="mt-4 w-full flex items-center justify-center space-x-2 text-red-600 hover:text-red-800 py-2 border-t border-gray-100"
      >
        <UserIcon className="h-5 w-5" />
        <span>Gestionar Usuarios</span>
      </button>
    </Card>
  );
};